module.exports = __webpack_public_path__ + "static/media/suspendont.5a46a66c.png";